import { DropdownItem } from '../../common/dropdown-item';

export enum CARRIER_RECRUITER_LOG_STAGE_UUID {
	'8ad358fc-869c-4847-89f3-101dc6071f72' = 'Carrier Added',
	'aa60a24c-a02a-4ac4-a7f3-155a714cad8b' = 'Excluded',
	'6f86f741-8c76-4450-934a-c667472d82bc' = 'Final Call',
	'4ff38b07-ec55-46c6-8a1f-7d35678cdbc1' = 'First Call',
	'3c8bf55f-4f9f-47d8-9193-f23aeb959208' = 'Lanes Added',
	'df0f0078-277b-4ec6-bfe1-db0ee459d120' = 'Onboarded',
}

export const CARRIER_RECRUITER_LOG_STAGE_UUID_MAP = {
	CARRIER_ADDED: '8ad358fc-869c-4847-89f3-101dc6071f72',
	EXCLUDED: 'aa60a24c-a02a-4ac4-a7f3-155a714cad8b',
	FINAL_CALL: '6f86f741-8c76-4450-934a-c667472d82bc',
	FIRST_CALL: '4ff38b07-ec55-46c6-8a1f-7d35678cdbc1',
	LANES_ADDED: '3c8bf55f-4f9f-47d8-9193-f23aeb959208',
	ONBOARDED: 'df0f0078-277b-4ec6-bfe1-db0ee459d120',
};

export const CARRIER_RECRUITER_STAGES: Array<DropdownItem> = [
	{
		label: 'Carrier Added',
		value: CARRIER_RECRUITER_LOG_STAGE_UUID_MAP.CARRIER_ADDED,
	},
	{
		label: 'Excluded',
		value: CARRIER_RECRUITER_LOG_STAGE_UUID_MAP.EXCLUDED,
	},
	{
		label: 'Final Call',
		value: CARRIER_RECRUITER_LOG_STAGE_UUID_MAP.FINAL_CALL,
	},
	{
		label: 'First Call',
		value: CARRIER_RECRUITER_LOG_STAGE_UUID_MAP.FIRST_CALL,
	},
	{
		label: 'Lanes Added',
		value: CARRIER_RECRUITER_LOG_STAGE_UUID_MAP.LANES_ADDED,
	},
	{
		label: 'Onboarded',
		value: CARRIER_RECRUITER_LOG_STAGE_UUID_MAP.ONBOARDED,
	},
];
